import React from "react";
import { react } from "mobx";
import { inject, observer } from "mobx-react";
import {BootstrapTable, ButtonGroup, TableHeaderColumn} from "react-bootstrap-table";
import {Button, Label} from "reactstrap";
import FontAwesome from 'react-fontawesome'
import {Component} from "react/lib/ReactBaseClasses";
import PropTypes from 'prop-types';
import CardMobile from "./CardLista";
import {formatarReal} from "../../../utils/formatar";
import {ModalForm} from "../../comum/components/ModalForm";
import {Link} from "react-router-dom";
import _ from "lodash";
import loading from '../../../assets/images/ajax-loader.gif';
import moment from "moment";
import TimesheetService from "../../../services/TimesheetService";

@inject("store")
@observer
class Tabela extends Component {

    static propTypes = {
        colunaOrdenacaoPadrao: PropTypes.string,
        tipoOrdenacaoPadrao: PropTypes.string,
        temBusca: PropTypes.bool,
        filtros: PropTypes.func,
        listaItens: PropTypes.array,
        colunaId: PropTypes.string,
        colunas: PropTypes.array,
        tabela: PropTypes.string,
        botoes: PropTypes.array,
        acoesItens: PropTypes.array,
        acoesMultiplas: PropTypes.array,
        funcaoOrdenacao: PropTypes.func,
        trClassName: PropTypes.func,
    };

    componentWillUnmount() {
        this.controller.onSelectAll(false, this.props.listaItens, this.props.keyField)
        this.controller.resetOrdenacao();
    }

    componentDidMount() {
        if(this.props.setTableRef) {
            this.props.setTableRef(this.refs.table);
        }
    }

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.modal = this.props.store.modalStore;
        this.loginStore = this.props.store.loginStore;
        this.timesheetService = new TimesheetService();

        this.botoesMobileTop = [];
        this.botoesMobileOnSelected = [];
        this.botoesMobileCard = [];

        this.controller = this.props.store.tabelaStore;

        // this.onRowSelect = this.onRowSelect.bind(this);
        // this.onSelectAll = this.onSelectAll.bind(this);
        this.gerarBotoes = this.gerarBotoes.bind(this);
    }

    modalOrdenar = () => {
        return this.props.colunas.map((coluna, i) =>
            <div key={i} className={coluna.field === _.get(this.controller.ordenacao , "field") ? 'selected' : ''}>
                <Button onClick={() => this.controller.setOrdenacao(coluna.field, this.refs.table)} className="col-md-12 text-left filterCollapseBtn" >
                    {coluna.label}
                    { coluna.field === _.get(this.controller.ordenacao , "field") ?
                        _.get(this.controller.ordenacao , "asc") ?
                            <FontAwesome name="caret-up" /> : <FontAwesome name="caret-down" />
                        : '' }
                </Button>
            </div>
        )
    };


    booleanFormat = (cell, row, enumObject, rowIndex) => {
        return cell ? "Sim" : "Não"
    };

    currencyFormat = (cell, row, enumObject, rowIndex) => {
        return formatarReal(cell)

    };

    percentageFormat = (cell, row, enumObject, rowIndex) => {
        return cell + "%"
    };

    modalForm(){
        if (this.modal.exibirModal.aberto) {
            switch (this.modal.exibirModal.tipo) {
                case 'solicitacaoBloqueada':
                    return (
                        <ModalForm
                            cabecalho={"Ação indisponível"}
                            corpo={this.modalAlerta()}
                            botoes={this.botoesDefault()}  />
                    );
                case 'prorrogacaoNaoPermitida':
                    return (
                        <ModalForm
                            cabecalho={"Prorrogação não permitida"}
                            corpo={this.modalProrrogacaoNaoPermitida()}
                            botoes={this.botoesDefault()}  />
                    );
                case 'prorrogacaoAtingiuLimiteMaximo':
                    return (
                        <ModalForm
                            cabecalho={"Prorrogação não permitida"}
                            corpo={this. modalProrrogacaoAtingiuLimiteMaximo()}
                            botoes={this.botoesDefault()}
                        />
                    )
                case 'prorrogacaoNaoPermitidaJustificativa':
                    return (
                        <ModalForm
                            cabecalho={"Prorrogação não permitida"}
                            corpo={this.modalProrrogacaoNaoPermitidaJustificativa()}
                            botoes={this.botoesDefault()}  />
                    );
                case 'migracaoNaoPermitida':
                    return (
                        <ModalForm
                            cabecalho={"Migração não permitida"}
                            corpo={this.modalMigracaoNaoPermitida()}
                            botoes={this.botoesDefault()}  />
                    );
                case 'ordenar':
                    return (
                        <ModalForm className="modalFilter"
                                   corpo={this.modalOrdenar()}
                                   closeButton={true}
                                   cabecalho={"Ordenar"}
                        />
                    );
                case 'filtrar':
                    return (
                        <ModalForm className="modalFilter"
                                   corpo={this.props.mobileFilter}
                                   closeButton={true}
                                   cabecalho={"Filtrar"}
                        />
                    );
                default:
                    return;
            }
        }
    };

    modalAlerta = () => {
        return(
            <div>
                <p>Não é possível criar uma nova solicitação pois existe a seguinte solicitação pendente:</p>
                <p><b>{this.modal.mensagemAlerta}</b></p>
            </div>
        );
    };

    modalProrrogacaoAtingiuLimiteMaximo = () => {
        return(
            <div>
                <p><b>{this.modal.mensagemAlerta}</b></p>
            </div>
        );
    };

    modalProrrogacaoNaoPermitida = () => {
        return(
            <div>
                <p>O prazo limite para renovação expirou.</p>
            </div>
        );
    };

    modalProrrogacaoNaoPermitidaJustificativa = () => {
        return(
            <div>
                <p>{this.modal.mensagemAlerta}</p>
            </div>
        );
    };

    modalMigracaoNaoPermitida = () => {
        return(
            <div>
                <p>Não é possível migrar alocação para contrato não iniciado.</p>
            </div>
        );
    }

    botoesDefault(){
        return (

            <div>
                <Button color="primary" onClick={() => this.modal.toggleModal()}>OK</Button>
            </div>
        )
    }

    mostrarModalSolicitacaoExistente = (row) => {
        if (row.solicitacaoPrazoId != null) {
            this.modal.mensagemAlerta = row.solicitacaoPrazoTipo == "PRO" ? "PR" + row.solicitacaoPrazoId : "TA" + row.solicitacaoPrazoId;
        } else {
            this.modal.mensagemAlerta = "SB"+row.solicitacaoSubstituicaoId;
        }

        this.modal.toggleModal('solicitacaoBloqueada');
    };

    mostrarModalAprovacaoNaoPermitida = () => {
        this.modal.toggleModal('prorrogacaoNaoPermitida')
    };

    mostrarModalProrrogacaoAtingiuLimiteMaximo = () => {
        this.modal. this.modal.mensagemAlerta("MEnsagem Modal alerta");
        this.modal.toggleModal('prorrogacaoAtingiuLimiteMaximo');
    };

    mostrarModalProrrogacaoNaoPermitida = (row) => {
        if (row.prorrogacoesPermitidasMax > 0) {
            this.modal.mensagemAlerta = "A quantidade de prorrogações atingiu o limite máximo definido na justificativa (" + row.prorrogacoesPermitidasMax + ").";
        } else {
            this.modal.mensagemAlerta = "A justificativa de contratação não permite prorrogação.";
        }
        this.modal.toggleModal('prorrogacaoNaoPermitidaJustificativa')
    }

    mostrarModalMigracaoNaoPermitida = () => {
        this.modal.toggleModal('migracaoNaoPermitida')
    }

    isContratoNaoIniciado = (row, itemAcao) => {
        if (itemAcao.tipo !== "migrar" || !row.dataInicio) {
            return false;
        }
        // Convert the row date to a moment object
        const dataInicioRow = moment(row.dataInicio, "DD/MM/YYYY"); // Assuming DD/MM/YYYY format
        if (!dataInicioRow.isValid()) {
            return false;
        }
        // Get the current date (only the date, without time)
        const hoje = moment().startOf('day');
        // Compare the dates and return true if the row date is greater
        return dataInicioRow.isAfter(hoje);
    }

    isExisteSolicitacaoAndamento = (row, itemAcao) => {
        return (row.solicitacaoPrazoId != null || row.solicitacaoSubstituicaoId != null) && (itemAcao.tipo === "anteciparTermino" || itemAcao.tipo === "prorrogar" || itemAcao.tipo === "substituir"|| itemAcao.tipo === "migrar")
    };

    isProrrogacaoNaoPermitida = (row, itemAcao) => {
        if((row.contRenovDiasMax === 0 || row.contRenovDiasMax) && row.dataInicio && row.dataTermino) {
            const contRenovDiasMax              = row.contRenovDiasMax;
            const dataInicio                    = moment(row.dataInicio, "DD/MM/YYYY");
            const dataTermino                   = moment(row.dataTermino, "DD/MM/YYYY");
            if (!dataInicio.isValid() || !dataTermino.isValid()) {
                return false;
            }
            const qtdDiasContrato               = dataTermino.diff(dataInicio, "days") + 1;
            return qtdDiasContrato >= contRenovDiasMax;
        } else {
            return false;
        }
    };

    isProrrogacaoNaoPermitidaJustificativa = (row, itemAcao) => {
        return  (itemAcao.tipo === "prorrogar") && (!row.podeRenovar)
    }

    actionButtons = (cell, row, enumObject, rowIndex) => {
        const actionsTable = [];

        this.botoesMobileCard = [];

        let acoesItens = this.props.acoesItens;

        if(this.props.botoesDinamicos) {
            acoesItens = acoesItens(row)
        }

        {acoesItens.map((itemAcao, i)=> {
            const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
            if (this.isExisteSolicitacaoAndamento(row, itemAcao)) {
                if(this.appStore.width > 768) {
                    actionsTable.push(<Button key={"botaoLinha" + rowIndex + i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} onClick={() => this.mostrarModalSolicitacaoExistente(row)}><FontAwesome name={itemAcao.icone} flip={itemAcao.flip}/></Button>)
                } else {
                    actionsTable.push(<a key={"botaoLinhaMobile" + rowIndex + i} className={"card-action"} onClick={() => this.mostrarModalSolicitacaoExistente(row)}><Button title={itemAcao.label}><FontAwesome className={itemAcao.cor ? itemAcao.cor : ""} name={itemAcao.icone} flip={itemAcao.flip}/></Button></a>)
                }
            } else if(this.isProrrogacaoNaoPermitida(row, itemAcao) && itemAcao.tipo === "prorrogar") {
                if(this.appStore.width > 768) {
                    actionsTable.push(<Button key={"botaoLinha" + rowIndex + i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} onClick={() => this.mostrarModalAprovacaoNaoPermitida()}><FontAwesome name={itemAcao.icone} flip={itemAcao.flip}/></Button>)
                } else {
                    this.botoesMobileCard.push(<a key={"botaoLinhaMobile" + rowIndex + i} className={"card-action"} onClick={() => this.mostrarModalAprovacaoNaoPermitida()}><Button title={itemAcao.label}><FontAwesome className={itemAcao.cor ? itemAcao.cor : ""} name={itemAcao.icone} flip={itemAcao.flip}/></Button></a>)
                }
            } else if(this.isProrrogacaoNaoPermitidaJustificativa(row, itemAcao)) {
                if(this.appStore.width > 768) {
                    actionsTable.push(<Button key={"botaoLinha" + rowIndex + i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} onClick={() => this.mostrarModalProrrogacaoNaoPermitida(row)}><FontAwesome name={itemAcao.icone} flip={itemAcao.flip}/></Button>)
                } else {
                    this.botoesMobileCard.push(<a key={"botaoLinhaMobile" + rowIndex + i} className={"card-action"} onClick={() => this.mostrarModalProrrogacaoNaoPermitida(row)}><Button title={itemAcao.label}><FontAwesome className={itemAcao.cor ? itemAcao.cor : ""} name={itemAcao.icone} flip={itemAcao.flip}/></Button></a>)
                }
            } else if(this.isContratoNaoIniciado(row, itemAcao)) {
                if(this.appStore.width > 768) {
                    actionsTable.push(<Button key={"botaoLinha" + rowIndex + i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} onClick={() => this.mostrarModalMigracaoNaoPermitida()}><FontAwesome name={itemAcao.icone} flip={itemAcao.flip}/></Button>)
                } else {
                    this.botoesMobileCard.push(<a key={"botaoLinhaMobile" + rowIndex + i} className={"card-action"} onClick={() => this.mostrarModalMigracaoNaoPermitida()}><Button title={itemAcao.label}><FontAwesome className={itemAcao.cor ? itemAcao.cor : ""} name={itemAcao.icone} flip={itemAcao.flip}/></Button></a>)
                }
            } else {
                const parametros = itemAcao.parametros ? itemAcao.parametros.map(p => _.get(row,p)).join("/") : _.get(row,itemAcao.parametro);
                if (typeof itemAcao.acao === 'function') {
                    const elem = itemAcao.acao(row, itemAcao, "" + rowIndex + i, parametros);
                    if (elem != null) actionsTable.push(elem);
                } else if(typeof itemAcao.acao === "string") {
                    actionsTable.push(<Link key={"botaoLinha" + rowIndex + i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} to={itemAcao.acao + "/"+ parametros}><FontAwesome name={itemAcao.icone} flip={itemAcao.flip}/></Link>)
                }
            }
        })}

        return (
            <div>
                {actionsTable}
            </div>);
    };

    gerarColunas = () =>  {
        const colunasTabela = [];
        this.props.colunas.map((column, i)=> {
            const tableProps = {
                key: i,
                dataField: column.field,
                sortFunc: column.funcaoOrdenacao,
                dataSort: true,
                width: this.appStore.width <= 768 && column.mobileWidth ? column.mobileWidth : "auto",
                tdStyle: column.style ? column.style : {whiteSpace: 'normal'},
                thStyle: column.style ? column.style : {whiteSpace: 'normal'}
            };
            if (column.dataFormat) {
                tableProps.dataFormat = column.dataFormat;
                tableProps.filterValue = column.filterValue ? column.filterValue : column.dataFormat;
            }
            else if (column.type === "boolean") {
                tableProps.dataFormat = this.booleanFormat;
                tableProps.filterValue = column.filterValue ? column.filterValue : this.booleanFormat;
            } else if (column.type === "currency") {
                tableProps.dataFormat = this.currencyFormat;
                tableProps.filterValue = column.filterValue ? column.filterValue : this.currencyFormat;
            } else if(column.type === "percentage") {
                tableProps.dataFormat = this.percentageFormat;
                tableProps.filterValue = column.filterValue ? column.filterValue : this.percentageFormat;
            }

            colunasTabela.push(<TableHeaderColumn columnTitle {...tableProps} > {column.label} </TableHeaderColumn>)
        });
        colunasTabela.push( <TableHeaderColumn key="actions" dataFormat={this.actionButtons} tdStyle={ {whiteSpace: 'normal', padding: 0, textAlign: 'right', verticalAlign: 'middle'} } width={"80"} /> );
        return colunasTabela;
    };

    gerarBotoes = () => {
        const botoes = [];
        this.botoesMobileTop = [];

        if(this.props.recarregar) {
            const recarregarButton = <Button key={1} className={"btn btn-secondary icon-button"} title={'Recarregar'} onClick={() => { this.props.recarregar() }}><FontAwesome name={'refresh'}/></Button>;

            botoes.push (recarregarButton);
            this.botoesMobileTop.push (recarregarButton)
        }
        if(this.props.upload && this.props.listaItens && this.props.listaItens.length > 0 && this.loginStore.isPerfilEttLogado) {
            const importacaoPlanilhaButton = <Button key={2} className={"btn btn-secondary icon-button"} title={'Importar'} onClick={() => { this.props.upload() }}><FontAwesome name={'upload'}/></Button>;
            const baixarModeloButton = <Button key={3} className={"btn btn-secondary icon-button"} title={'Baixar modelo planilha'} onClick={() => this.timesheetService.downloadModeloPlanilha()}><FontAwesome name={'cloud-download'}/></Button>;

            botoes.push (importacaoPlanilhaButton);
            botoes.push (baixarModeloButton);
            this.botoesMobileTop.push (importacaoPlanilhaButton);
            this.botoesMobileTop.push (baixarModeloButton)
        }

        if(this.props.botoes && this.props.botoes.length > 0) {
            this.props.botoes.map((botao, i)=> {
                botoes.push ( <Button key={"a" + i} color="primary" onClick={ () => botao.acao()}>{ botao.label }</Button> );
                this.botoesMobileTop.push (<Button key={"a" + i} color="primary" onClick={ () => botao.acao()}>{ botao.label }</Button>);
            });
        } else if(this.props.acoesMultiplas && this.props.acoesMultiplas.length > 0) {
            this.props.acoesMultiplas.map((botao, i)=> {
                botoes.push ( <Button key={"b" + i} disabled={this.controller.selected.length < 1} title={botao.label} onClick={() => botao.acao(this.refs.table.state.selectedRowKeys)}>{botao.icone ? <FontAwesome name={botao.icone} /> : botao.label }</Button> );
                this.botoesMobileOnSelected.push(<a key={"b" + i} onClick={() => botao.acao(this.refs.table.state.selectedRowKeys)}><FontAwesome name={botao.icone} /></a>)
            });
        }

        return <ButtonGroup sizeClass='btn-group-md'>{botoes}</ButtonGroup>
    };

    temBotoesAcima = () => {
        // Determina se há botões de ações acima da tabela
        return (this.props.loading || this.props.botoes && this.props.botoes.length > 0) || 
               (this.props.acoesMultiplas && this.props.acoesMultiplas.length > 0) || 
               this.props.recarregar;
    };

    onChangeLista = (lista) => {
        if(this.refs.table) {
            this.refs.table.state.data = lista;
        }
    };

    render() {

        const selectRowProp = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: (obj) => this.controller.onRowSelect(obj, this.props.keyField, this.props.onChange),
            onSelectAll: (isSelected, lista) => this.controller.onSelectAll(isSelected, lista, this.props.keyField),
            selected: this.controller.selected
        };

        const options_table = {
            noDataText: this.props.loading ? <img src={loading} alt="loading" className="loading"/> : "Não há registros.",
            defaultSortName: this.props.colunaOrdenacaoPadrao,
            defaultSortOrder: this.props.tipoOrdenacaoPadrao,
            sizePerPageList:   
            [{
                text: '10', value: 10
            }, {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            }, {
                text: 'Todos', value: this.props.listaItens.length
            }],
            // usa botões customizados na toolbar sem habilitar insertRow
            // evitando que o react-bootstrap-table monte o modal interno "Add Row"
            btnGroup: this.gerarBotoes
        };

        this.props.colunas.map(column => {
            if(column.ordemInicial) {
                options_table.defaultSortName = column.field;
                options_table.defaultSortOrder = column.ordemInicial;
            }
        });

        // Usar diretamente props.listaItens ao invés de this.refs.table.state.data
        // para evitar problemas de sincronização em mobile quando dados vêm de toJS()
        const listaMobile = this.props.listaItens || [];

        return (
            <div>
                {this.props.filtros}
                {/*MOBILE*/}
                <div className={this.appStore.width <= 768 && this.props.useCardsMobile ? "show-item" : "hide-item"}>
                    {this.props.loading ? (
                        <div className="loading-mobile">
                            <img src={loading} alt="loading" className="loading"/>
                        </div>
                    ) : (
                        <CardMobile
                            keyField={this.props.keyField ? this.props.keyField : "id"}
                            listaItens={listaMobile}
                            title={this.props.tituloMobile}
                            content={this.props.conteudoMobile}
                            extras={this.props.extraMobile}
                            actions={this.props.acoesItens}
                            onChange={this.onChangeLista}
                            botoesMobileOnSelected={this.botoesMobileOnSelected}
                            botoesMobileTop={this.botoesMobileTop}
                            onCardClick={this.props.onCardClick}
                            botoesMobileCard={(row, rowIndex) => this.actionButtons(null, row, null, rowIndex)}
                        />
                    )}
                </div>
                {/*DESKTOP*/}
                <div className={this.appStore.width <= 768 && this.props.loading && !this.props.useCardsMobile ? "hide-item" : "show-item"}>
                    <BootstrapTable
                        className={this.props.useCardsMobile ? "table-and-cards" : ""}
                        trClassName={this.props.trClassName}
                        ref='table'
                        version='4'
                        keyField={this.props.keyField ? this.props.keyField : "id"}
                        data={this.props.listaItens}
                        insertRow={false}
                        striped
                        hover
                        pagination = {this.props.listaItens.length >=10} 
                        options={options_table}
                        search={this.props.temBusca}
                        condensed
                        selectRow={this.props.acoesMultiplas && this.props.acoesMultiplas.length > 0 ? selectRowProp : {}}
                        searchPlaceholder="Pesquisar"
                    >
                        { this.gerarColunas() }
                    </BootstrapTable>
                </div>
                {this.modalForm()}
            </div>
        );
    }
};

export {Tabela}